import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { formatEventDate } from '../../utils/dateFormatter';
import { H5, H6, Body3, Body2 } from '../../themes/typography';

export default function ScheduleSection({ previewData }) {
    const singleDayEventSchedule = previewData?.schedules?.[0] || {};
    const isSingleDayEventWithSlots =
        previewData?.event_type === 'single_day' && singleDayEventSchedule?.slots?.length > 0;

    function renderSchedule() {
        if (isSingleDayEventWithSlots) {
            return (
                <ExpandedScheduleAccordion
                    date={formatEventDate(singleDayEventSchedule.date)}
                    startTime={singleDayEventSchedule.start_time}
                    endTime={singleDayEventSchedule.end_time}
                    slots={singleDayEventSchedule.slots}
                />
            );
        }

        if (previewData.event_type === 'multi_day') {
            return previewData.schedules.map((schedule, index) =>
                schedule?.slots?.length > 0 ? (
                    <ExpandedScheduleAccordion
                        key={index}
                        date={formatEventDate(schedule.date)}
                        startTime={schedule.start_time}
                        endTime={schedule.end_time}
                        slots={schedule.slots}
                    />
                ) : (
                    <SingleScheduleAccordion
                        key={index}
                        date={formatEventDate(schedule.date)}
                        startTime={schedule.start_time}
                        endTime={schedule.end_time}
                    />
                )
            );
        }
    }

    return (
        <div className="event-preview-schedule-container">
            <H5 fontWeight={700}>Event Schedule</H5>

            <div className="event-preview-schedule-accordions-container">{renderSchedule()}</div>
        </div>
    );
}

function SingleScheduleAccordion({
    date = 'Mon, 25 Dec 2023',
    startTime = '10:00 AM',
    endTime = '11:00 AM'
}) {
    return (
        <Accordion
            disabled={true}
            sx={{
                alignSelf: 'stretch',
                background: 'var(--gradient-blue)',
                borderRadius: '1rem !important'
            }}
        >
            <AccordionSummary
                sx={{
                    '&.Mui-disabled': {
                        opacity: '1'
                    }
                }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.15rem' }}>
                    <H6 color="var(--secondary-color)">{date}</H6>
                    <Body3>
                        {startTime} - {endTime}
                    </Body3>
                </div>
            </AccordionSummary>
        </Accordion>
    );
}

function ExpandedScheduleAccordion({
    date = 'Mon, 25 Dec 2023',
    startTime = '10:00 AM',
    endTime = '11:00 AM',
    slots = []
}) {
    return (
        <Accordion
            sx={{
                alignSelf: 'stretch',
                background: 'var(--gradient-blue)',
                borderRadius: '1rem !important'
            }}
        >
            <AccordionSummary expandIcon={<ExpandMore sx={{ color: 'var(--quaternary-color)' }} />}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.15rem' }}>
                    <H6 color="var(--secondary-color)">{date}</H6>
                    <Body3>
                        {startTime} - {endTime}
                    </Body3>
                </div>
            </AccordionSummary>
            <AccordionDetails sx={{ paddingTop: '0' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                    {slots?.map((slot, index) => (
                        <div key={slot.id}>
                            <Body2>
                                Slot {index + 1}: {slot.from_time} - {slot.to_time}
                            </Body2>
                        </div>
                    ))}
                </div>
            </AccordionDetails>
        </Accordion>
    );
}
